import React from "react";
import { useHistory } from "react-router-dom";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
const Objective = (props) => {
  const history = useHistory();
  return (
    <div id="page">
      <Header onBack={() => history.push("/choosetype")} />
      <Footer />
      <div className="page-content header-clear-medium">
        <div class="row text-center mb-3 justify-content-center">
          <a onClick={()=>{props.setstep('orientation')}} href="javascript:;" class="col-6">
            <div class="card card-style mb-3">
              <i class="fas fa-chart-area color-magenta-dark fa-3x mt-5"></i>
              <h3 class="pt-4">Plotting Discontinuity Trace</h3>
              <p class="font-11 opacity-50 mt-n2">Plotting Discontinuity Trace on the Tunnel Log</p>
              <p class="mb-0 pb-0 font-10 opacity-40">Tap to View</p>
            </div>
          </a>
          {/* The Computing Discontinuity Orientation activity now lives in the
              DisDip web tool, and the orientation-source screen covers
              orientation from face logs or known chainages; its components
              stay routable here. */}
          {/* <a onClick={()=>{props.setstep('heading')}} href="javascript:;" class="col-4 ps-0">
            <div class="card card-style ms-2 mb-3">
              <i class="fas fa-heading color-highlight fa-3x mt-5"></i>
              <h3 class="pt-4">Projection from heading</h3>
              <p class="font-11 opacity-50 mt-n2">Projection Heading Log Plot</p>
              <p class="mb-0 pb-0 font-10 opacity-40">Tap to View</p>
            </div>
          </a> */}
          </div>
      </div>
    </div>
  );
};

export default Objective;
